import React from 'react'
import { MdBookmark, MdBookmarkBorder } from 'react-icons/md'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import Box from '../Icons/Box'
import Chat from '../Icons/Chat'
import Process from '../Icons/Process'
import MegaPhone from '../Icons/MegaPhone'
import Card from '../Card/Card'
import Flex from '../Flex/Flex'
import Text from '../Text/Text'
import Thumbnail from '../Thumbnail/Thumbnail'
import styles from './cardContentSmall.module.scss'

const CardContentSmall = (props) => {
  const {
    title,
    updatedAt,
    category,
    className,
    isMarked,
    pressMarker,
    onPress
  } = props

  const classesCard = classNames(styles.container, className)

  const renderIconPerCategory = (categoryCode) => {
    switch (categoryCode) {
      case 4:
        return <Box />
      case 2:
        return <Chat />
      case 3:
        return <Process />
      default:
        return <MegaPhone />
    }
  }

  return (
    <Card className={classesCard}>
      <Flex column justifyContent="space-evenly" flex="1">
        <Flex onClick={onPress} style={{ cursor: 'pointer' }}>
          <div>
            <Thumbnail gradient type={category} className={styles.icon}>
              {renderIconPerCategory(category)}
            </Thumbnail>
          </div>
          <Flex column>
            <Text
              size="xs"
              lineHeight="24px"
              color="gray"
              variation="dark"
              bold
              className={styles.elipsis}
            >
              {title}
            </Text>
            <Text
              size="xxs"
              lineHeight="18px"
              color="gray"
              variation="light"
              font="custom"
            >
              {updatedAt}
            </Text>
          </Flex>
        </Flex>
        <Flex alignItems="center" justifyContent="flex-end">
          <button
            className={styles.buttonMarker}
            type="button"
            onClick={pressMarker}
          >
            {isMarked ? (
              <MdBookmark color="#4d4d4d" size={20} />
            ) : (
              <MdBookmarkBorder color="#4d4d4d" size={20} />
            )}
          </button>
        </Flex>
      </Flex>
    </Card>
  )
}

CardContentSmall.defaultProps = {
  className: null,
  isMarked: false,
  onPress: null
}

CardContentSmall.propTypes = {
  title: PropTypes.string.isRequired,
  updatedAt: PropTypes.string.isRequired,
  className: PropTypes.string,
  category: PropTypes.number.isRequired,
  isMarked: PropTypes.bool,
  pressMarker: PropTypes.func.isRequired,
  onPress: PropTypes.func
}

export default CardContentSmall
